export default __webpack_public_path__ + "static/media/DoubleLeft.ad42e88d.svg";